function MainContainer({ children = null }) {

	return (
		<section className="container mx-auto px-5 py-5 sm:py-10 sm:px-20 mt-16 relative">
			{children}
		</section>
	);
}
export default MainContainer;